<div [ngClass]="{'dark-theme': (themeService.currentTheme$ | async) === 'dark', 'light-theme': (themeService.currentTheme$ | async) === 'light'}">
  <div *ngIf="isCurrentOAuthCallbackRoute()" class="oauth-callback-layout">
    <router-outlet></router-outlet>
  </div>

  <!-- Layout de autenticacion -->
  <div *ngIf="!isCurrentOAuthCallbackRoute() && isAuthRoute()" class="auth-layout">
    <router-outlet></router-outlet>
  </div>

  <!-- Layout principal -->
  <div *ngIf="!isCurrentOAuthCallbackRoute() && !isAuthRoute()" class="main-layout" [ngClass]="{'sidebar-collapsed': isSidebarCollapsed}">
    <!-- Sidebar -->
    <app-sidebar (toggleSidebar)="toggleSidebar()"
                 [ngClass]="{'collapsed': isSidebarCollapsed}"
                 [class.show]="isMobile && isSidebarOpenMobile"></app-sidebar>

    <div class="content-wrapper">
      <!-- Header -->
      <app-header (menuToggle)="toggleSidebar()"></app-header>
      <app-notification-toast></app-notification-toast>

      <!-- Contenido principal -->
      <main class="main-content" [ngClass]="{ 'chat-view': isChatRoute() }">
        <router-outlet></router-outlet>
      </main>

      <!-- Footer -->
      <app-footer></app-footer>
    </div>
  </div>
  <!-- Mobile overlay backdrop when sidebar is open -->
  <div *ngIf="!isCurrentOAuthCallbackRoute() && isMobile && isSidebarOpenMobile" class="backdrop" (click)="toggleSidebar()"></div>
</div>
